/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_qty = /** @type {(inputs: {}) => string} */ () => {
	return `Mno.`
};

const da_qty = /** @type {(inputs: {}) => string} */ () => {
	return `Antal`
};

const de_qty = /** @type {(inputs: {}) => string} */ () => {
	return `Stk.`
};

const en_qty = /** @type {(inputs: {}) => string} */ () => {
	return `Qty`
};

const es_qty = /** @type {(inputs: {}) => string} */ () => {
	return `Cant.`
};

const fr_qty = /** @type {(inputs: {}) => string} */ () => {
	return `Qté`
};

const hu_qty = /** @type {(inputs: {}) => string} */ () => {
	return `Menny.`
};

const it_qty = /** @type {(inputs: {}) => string} */ () => {
	return `Qtà`
};

const nl_qty = /** @type {(inputs: {}) => string} */ () => {
	return `Aantal`
};

const pl_qty = /** @type {(inputs: {}) => string} */ () => {
	return `Szt.`
};

const pt_qty = /** @type {(inputs: {}) => string} */ () => {
	return `Qtd`
};

const sv_qty = /** @type {(inputs: {}) => string} */ () => {
	return `Antal`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qty(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("qty", locale)
	if (locale === "cs") return cs_qty(inputs)
	if (locale === "da") return da_qty(inputs)
	if (locale === "de") return de_qty(inputs)
	if (locale === "en") return en_qty(inputs)
	if (locale === "es") return es_qty(inputs)
	if (locale === "fr") return fr_qty(inputs)
	if (locale === "hu") return hu_qty(inputs)
	if (locale === "it") return it_qty(inputs)
	if (locale === "nl") return nl_qty(inputs)
	if (locale === "pl") return pl_qty(inputs)
	if (locale === "pt") return pt_qty(inputs)
	return sv_qty(inputs)
};